import { isAxiosRestFailure } from './restApiError';

let registered = false;

/**
 * Prevents dev overlay / noisy unhandledrejection for ApiClientError instances
 * that were already produced by the shared axios error interceptor.
 */
export function registerRestRejectionFailsafe() {
  if (registered || typeof window === 'undefined') {
    return;
  }
  registered = true;

  window.addEventListener('unhandledrejection', (event) => {
    const reason = event.reason;
    if (!isAxiosRestFailure(reason)) {
      return;
    }
    event.preventDefault();
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.debug('[REST rejection handled]', {
        message: reason?.message,
        requestId: reason?.requestId,
        url: reason?.url,
      });
    }
  });
}

registerRestRejectionFailsafe();
